export default "__VITE_ASSET__foJ9hK30__"